function mapInit(center, iconCoord, id) {
    var mapId = id || 'myMap';
    if (id === 'objects-map-init') {
        function init1 () {

            var myMap = new ymaps.Map(mapId, {

                    center: [54.735147, 55.958727],
                    zoom: 10,
                    controls: []
                    //type:'yandex#hybrid'
                }),

                /* myMap.controls

                     .add('zoomControl')

                     .add('typeSelector', { right: 30, top: 5 })*/

                myPlacemark1 = new ymaps.Placemark(

                    [54.814865, 55.884041],{  balloonContentBody: [
                            '<address>',
                            'село Михайловка\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark2 = new ymaps.Placemark(

                    [54.778279, 55.825318],{  balloonContentBody: [
                            '<address>',
                            'село Миловка\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark3 = new ymaps.Placemark(

                    [54.653422, 55.757424],{  balloonContentBody: [
                            '<address>',
                            'село Жуково\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark4 = new ymaps.Placemark(

                    [54.688066, 56.135695],{  balloonContentBody: [
                            '<address>',
                            'село Фёдоровка\n' +
                            'городской округ Уфа, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark5 = new ymaps.Placemark(

                    [54.658100, 56.212294],{  balloonContentBody: [
                            '<address>',
                            'деревня Шамонино\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    });

            myMap.behaviors.disable('scrollZoom');

            myMap.geoObjects
                .add(myPlacemark1)
                .add(myPlacemark2)
                .add(myPlacemark3)
                .add(myPlacemark4)
                .add(myPlacemark5)
        }
    } else if (id === 'land-plots-map') {
        function init1 () {

            var myMap = new ymaps.Map(mapId, {

                    center: [54.735147, 55.958727],
                    zoom: 10,
                    controls: []
                    //type:'yandex#hybrid'
                }),

                /* myMap.controls

                     .add('zoomControl')

                     .add('typeSelector', { right: 30, top: 5 })*/

                myPlacemark1 = new ymaps.Placemark(

                    [54.814865, 55.884041],{  balloonContentBody: [
                            '<address>',
                            'село Михайловка\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark2 = new ymaps.Placemark(

                    [54.778279, 55.825318],{  balloonContentBody: [
                            '<address>',
                            'село Миловка\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark3 = new ymaps.Placemark(

                    [54.653422, 55.757424],{  balloonContentBody: [
                            '<address>',
                            'село Жуково\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark4 = new ymaps.Placemark(

                    [54.688066, 56.135695],{  balloonContentBody: [
                            '<address>',
                            'село Фёдоровка\n' +
                            'городской округ Уфа, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    }),
                myPlacemark5 = new ymaps.Placemark(

                    [54.658100, 56.212294],{  balloonContentBody: [
                            '<address>',
                            'деревня Шамонино\n' +
                            'Уфимский район, Республика Башкортостан, Россия',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    });

            myMap.behaviors.disable('scrollZoom');

            myMap.geoObjects
                .add(myPlacemark1)
                .add(myPlacemark2)
                .add(myPlacemark3)
                .add(myPlacemark4)
                .add(myPlacemark5)
        }
    } else {
        function init1 () {

            var myMap = new ymaps.Map(mapId, {

                    center: center,//[54.712258, 55.987599],
                    zoom: 16,
                    controls: []
                    //type:'yandex#hybrid'
                });

                /* myMap.controls

                     .add('zoomControl')

                     .add('typeSelector', { right: 30, top: 5 })*/
                var myPlacemark = new ymaps.Placemark(

                    iconCoord,{  balloonContentBody: [
                            '<address>',
                            'Рі.&nbsp;РЈС„Р°, СѓР». РњРµРЅРґРµР»РµРµРІР°, 150/5\n',
                            '</address>'
                        ].join('')
                    }, {

                        iconLayout: 'default#image',
                        iconImageHref: '/img/map_icon.png',
                        iconImageSize: [30, 50],
                        iconImageOffset: [-18, -45]
                    });

            myMap.behaviors.disable('scrollZoom');

            myMap.geoObjects
                .add(myPlacemark);
        }
    }
    ymaps.ready(init1);
}